import React, { Component, Fragment } from "react";
import { setStore } from "Pub/js/storageUtils";
import { deleteRecentVisit } from "Pub/js/utils";
import _, { set } from "lodash";
import Ajax from "Pub/js/ajax";
import "./index.less";
import { langCheck, throttle, getMyAppInfoValue } from "Pub/js/utils";
import platform from "Pub/js/platform";
import { scroller, Element } from 'react-scroll';
import Notice from "Components/Notice";
import { QuickAddIcon } from "Components/QuickLaunchIcon";
import * as NavAppIcons from 'Pub/js/navNodeIcons';
const { base, getLangCode } = platform;
const { NCTooltip } = base;
import CollectTooltip from 'Components/CollectTooltip';
// import Question from "Assets/images/menuicons/question.svg";
import MyCollect1 from "Assets/images/menuicons/my_collect1.svg";
import RecentVisitImg from "Assets/images/menuicons/zuijinfangwen.svg";
import { connect } from "react-redux";
import { ControlTip } from "Components/ControlTip";
import { RECENTVISIT, MYCOLLECT, NOTMYAPP } from 'Pub/js/allApps';
import NoData from "Assets/images/no-data.png";

class MyContent extends Component {
    constructor(props) {
        super(props);
    }
    componentWillReceiveProps(nextProps) {
        if (!this.keepMenuPosition) { // 菜单点击时保持位置不动
            this.scrollToActived(nextProps);
        }
        if (this.props.showAllApp && !nextProps.showAllApp) { // 关闭菜单弹窗
            this.keepMenuPosition = null; // 置空
        }
    }

    scrollToActived = (props) => {
        let { contentData, navAppInfo } = props;
        if (contentData && contentData.length) {
            let firstLevelModule = this.findFirstLevelModule(contentData, navAppInfo) || contentData[0];
            if (firstLevelModule) {
                const scrollToName = `app_group_${firstLevelModule.value}`;
                setTimeout(() => {
                    scroller.scrollTo(scrollToName, {
                        spy: true,
                        smooth: false,
                        duration: 250,
                        containerId: 'domain-apps-wrapper',
                    });
                });
            }
        }
    }

    // 获取 标题
    getTitle = (b3, b4) => {
        // 当为五级菜单时 用b4的值来匹配标题
        let title = b3;
        if (b4) {
            title = b4;
        }
        return title;
    }
    findFirstLevelModule = (contentData, navAppInfo) => {
        if (!navAppInfo) { return undefined; }
        let { b3 = null, b4 = null } = navAppInfo || {};
        const title = this.getTitle(b3, b4);
        let level1 = _.find(contentData, item => item.label === title);
        return level1;
    }

    getOpenParams = (c) => {
        let isMyApp = 0; // 0 默认 1 我的收藏 2 最近访问
        const { value } = c;
        if (value === MYCOLLECT) {
            isMyApp = 1;
        } else if (value === RECENTVISIT) {
            isMyApp = 2;
        }
        return {
            isMyApp
        }
    }

    onContentClick = throttle((e, c) => {
        const { contentData, navAppInfo } = this.props;
        let target = e.target;
        let isAppBtn = target.hasAttribute('open-type');
        let grpIdx = target.getAttribute('grp-index');
        let itemIdx = target.getAttribute('item-index');
        let openType = target.getAttribute('open-type');
        let itemData;
        if (!isAppBtn) { return; }
        itemData = _.result(contentData, `[${grpIdx}].children[${itemIdx}]`);
        // // 如果注册首页节点 新页签打开
        // if (itemData && itemData.menuitemcode === "20001902") {
        //     window.open(`${window.location.href}`)
        //     return
        // }
        if (itemData) {
            // 存取知识条目
            // setStore("knowledgeApp", { appcode: itemData.appcode, appid: itemData.appid });
            if (itemData.code) {
                itemData.menuitemcode = itemData.code; //传菜单编码
            }
            window.openNew(itemData, null, null, {
                openTabWithoutCheck: openType === 'newtab',
                ...this.getOpenParams(c),
            });
            const otherAppInfo = { // 最后两级菜单的信息
                n: itemData.label // 末级菜单是n
            };
            if (navAppInfo.thirdValue) {
                otherAppInfo.b4 = c.label; // 五级菜单是b4
                // 最后一级存在同名的，记录一下编码，和面包屑数据字段保持一致，便于获取
                otherAppInfo.fifthmenucode = itemData.code;
            } else {
                otherAppInfo.b3 = c.label; // 四级菜单是b3
                otherAppInfo.menucode = itemData.code;
            }
            this.props.updateModuleInfo({
                ...navAppInfo,
                ...otherAppInfo
            }, false);
        }
    }, 500)
    // 我的应用里 我的收藏 或者 最近访问 为空时
    renderNoMyApp = value => {
        return <div className="no-collect">
            <div className="title-box">
                <img src={value === MYCOLLECT ? MyCollect1 : RecentVisitImg} />
                { /**  我的收藏--多语   最近访问 */}
                {value === MYCOLLECT ? <span>{langCheck('0000PUB-000404')}</span> :
                    <span>{langCheck("0000PUB-000342")}</span>}
                {value === MYCOLLECT && this.collectNCTooltip(value)}
            </div>
            <div className={`content-box`}>
                {
                    value === MYCOLLECT ? <div className="star-bg">
                        <i className="iconfont icon-shoucanghuise icon-star" />
                    </div> : <img className='no-data-img' src={NoData} />
                }
                {
                    // 请移步应用菜单添加收藏 - 多语  暂无最近访问记录
                    value === MYCOLLECT ? <span>{langCheck('0000PUB-000405')} </span > : <span>{langCheck("0000PUB-000554")}</span>
                }
            </div>
        </div>;
    }
    collectNCTooltip = value => {
        let overlay = langCheck('0000PUB-000409'); /**多语- 最多可添加60个应用*/
        if (value && value === RECENTVISIT) {
            overlay = langCheck("0000PUB-000553"); /**多语- 最多可展示60个访问历史*/
        }
        return <NCTooltip
            className="app-tooltip"
            overlay={overlay}
            trigger='hover'
            delayShow={500}
            delay={1}
            getPopupContainer={() => this.appsContainerRef}
        >
            {/* <img className="question" src={Question} /> */}
            <i className="question iconfont icon-bangzhutishi"></i>
        </NCTooltip>;
    }
    // 一键清空我的收藏
    clearCollect = () => {
        Ajax({
            url: `/nccloud/platform/appregister/clearappcollect.do`,
            success: res => {
                const { success } = res.data;
                if (success) {
                    let { contentData, clearContentData } = this.props;
                    const newContentChildren = _.cloneDeep(contentData[0]).children.map(item => {
                        item.is_collect = false;
                        return item;
                    });
                    const newContentData = [
                        {
                            image_src: MyCollect1,
                            label: langCheck('0000PUB-000404'), //我的收藏-多语
                            children: newContentChildren,
                        },
                    ];
                    clearContentData(newContentData);
                    Notice({
                        status: "success",
                        msg: langCheck('0000PUB-000406'), //删除成功-多语
                    });
                }
            },
        });
    }
    // 清空最近访问
    clearRecent = () => {
        let { clearContentData, contentData } = this.props;
        ControlTip({
            status: "warning",
            title: langCheck("0000PUB-000311"),
            msg: langCheck("0000PUB-000281") /* 国际化处理： 确定要清空最近访问?*/,
            zIndex: 1000,
            onOk: () => {
                deleteRecentVisit().then(flag => {
                    if (flag) {
                        const newContentData = [
                            { ...contentData[0] },
                            {
                                image_src: RecentVisitImg,
                                label: langCheck('0000PUB-000552'), //我的应用-多语
                                children: [],
                            },
                        ];
                        clearContentData(newContentData);
                        Notice({
                            status: "success",
                            msg: langCheck('0000PUB-000406'), //删除成功-多语
                        });
                    }
                });
            },
        });
    };
    //为收藏图标加不同的key
    getCollectKey = () => {
        const { contentData } = this.props;
        let collectKey = 0;
        if (contentData && contentData.length) {
            contentData.forEach(item => {
                const { value } = item;
                if (value === MYCOLLECT) {
                    collectKey = 1;
                } else if (value === RECENTVISIT) {
                    collectKey = 2;
                }
            });
        }
        return collectKey;
    }
    // 应用是否高亮显示
    getItemAppFlag = (child) => {
        const { navAppInfo } = this.props;
        const { menucode, fifthmenucode, n } = navAppInfo;
        const { code, label } = child;
        const currentKey = getMyAppInfoValue();
        // 有编码的话比对编码，没有再比对名称
        const isSame = code && (fifthmenucode || menucode) ? (fifthmenucode === code || menucode === code) : label === n;
        let flag = false;
        if (!currentKey) {
            if (isSame) {
                flag = true;
            }
        } else {
            if (currentKey === NOTMYAPP) {
                if (isSame) {
                    flag = true;
                }
            } else {
                if (currentKey === MYCOLLECT && isSame) {
                    flag = true;
                } else if (currentKey === RECENTVISIT && isSame) {
                    flag = true;
                }
            }
        }
        return flag;
    }
    //渲染右侧应用菜单信息
    render() {
        const { contentData, navAppInfo, setNewContentData, nccFont, moduleId, getMyappData } = this.props;
        let collectKey = this.getCollectKey();
        let { n = null, b3 = null, b4 = null } = navAppInfo || {};
        const title = this.getTitle(b3, b4);
        let itemAppMinWidth = '255px';
        const langCode = getLangCode();
        switch (nccFont.fontSize) {
            case 'medium':
                itemAppMinWidth = '278px';
                break;
            case 'large':
                itemAppMinWidth = '310px';
                break;
            default:
                break;
        }
        // if (moduleId && Object.keys(moduleId).length === 0 && collectKey === 0) { return null; }  // 目前切到我的应用时会闪一下 先去掉
        return (
            <Element
                className="domain-apps-wrapper"
                id="domain-apps-wrapper"
            >
                <div
                    className="content domain-apps-container"
                    id="domain-apps-container"
                    fieldid="nav-node"
                    ref={ref => this.appsContainerRef = ref}
                >
                    <div className="content-wrap" id="content-wrap">
                        {contentData.length ? contentData.map((c, index) => {
                            let appIcon = (<img src={c.image_src ? c.image_src : NavAppIcons.optimize['default']} />);

                            return (
                                <Element
                                    className={`content-item${c.label === title ? ' active' : ''}`}
                                    key={c.code || index}
                                    name={`app_group_${c.value}`}
                                >
                                    {
                                        c && c.children.length ? <Fragment><div className="content-item-header">
                                            {/* <i className={`iconfont ${c.icon || 'icon-liebiao'}`}/> */}
                                            {appIcon}
                                            <span>{c.label}</span>
                                            {c.value === MYCOLLECT && this.collectNCTooltip(c.value)}
                                        </div>
                                            <div className="content-item-content">
                                                {c.children.map((child, i) => {
                                                    const flag = this.getItemAppFlag(child);
                                                    return (
                                                        <div
                                                            key={child.code || i}
                                                            className={
                                                                `item-app${flag ? ' active' : ''}`
                                                            }
                                                            open-type="tab"
                                                            grp-index={index}
                                                            item-index={i}
                                                            onClickCapture={() => {
                                                                this.keepMenuPosition = true;
                                                            }}
                                                            onClick={e => { this.onContentClick(e, c); }}
                                                            title={child.label}
                                                            style={{ minWidth: itemAppMinWidth }}
                                                        >
                                                            {
                                                                langCode === 'english'
                                                                    ?
                                                                    (child.label.length > 67 ? child.label.substring(0, 66) + '...' : child.label) // 超出展示66个字符加...
                                                                    :
                                                                    (child.label.length > 25 ? child.label.substring(0, 22) + '...' : child.label)
                                                            }
                                                            <div className="icon-content">
                                                                {/* 快速发起-新增 */}
                                                                <QuickAddIcon visible={!!child.fastlaunchparam} appData={child} openParams={this.getOpenParams(c)} />
                                                                <NCTooltip
                                                                    className="app-tooltip"
                                                                    placement='top'
                                                                    overlay={langCheck('0000PUB-000372')}
                                                                    /**在新标签中打开 */
                                                                    trigger='hover'
                                                                    delayShow={500}
                                                                    delay={1}
                                                                    getPopupContainer={() => this.appsContainerRef}
                                                                >
                                                                    <i
                                                                        className="iconfont icon-xinyeqiandakai app-open"
                                                                        grp-index={index}
                                                                        item-index={i}
                                                                        open-type="newtab"
                                                                    />
                                                                </NCTooltip>
                                                                <CollectTooltip
                                                                    isAllapps={true}
                                                                    key={`${child.appcode}${collectKey}`}
                                                                    itemData={{
                                                                        appcode: child.appcode,
                                                                        menuitemid: child.menuitemid || child.value,
                                                                        menuitemcode: child.menuitemcode || child.code,
                                                                        is_collect: child.is_collect,
                                                                        is_cloud_app: child.is_cloud_app,
                                                                    }}
                                                                    contentData={contentData}
                                                                    setNewContentData={setNewContentData}
                                                                    isRecentVisit={contentData[index].value === RECENTVISIT} //是否从我的应用 最近访问 里触发
                                                                    getMyappData={getMyappData}
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </Fragment>
                                            : this.renderNoMyApp(c.value)
                                    }
                                    {contentData[index].value === RECENTVISIT && contentData[index].children.length ?
                                        <div className="clear-collect" onClick={this.clearRecent}>
                                            <i className='iconfont icon-shanchu5'></i>
                                            {/* 清空 */}
                                            <span>{langCheck("0000PUB-000311")}</span>
                                        </div> : ''}
                                </Element>
                            );
                        }) : ''}
                    </div>
                </div>
            </Element >
        );
    }
}

export default connect(
    ({ appData }) => ({ nccFont: appData.nccFont }), {},
)(MyContent);
